import ctaTypes from '../../../../enums/CTA.enums';
import { TIconFromRenderingParams } from '../../../../types/sitecore.types';
import { IComponentProps, TSitecoreContext } from '../../../../types/types';

export const CtaStylesCtaTypeObj = {
  'Primary Orange': ctaTypes['primaryOrange'],
  'Primary White': ctaTypes['primaryWhite'],
  'Primary Black': ctaTypes['primaryBlack'],
  'Secondary Black': ctaTypes['secondaryBlack'],
  'Secondary White': ctaTypes['secondaryWhite'],
  'CaseCE Primary Orange': ctaTypes['primaryOrange'],
  'CaseCE Primary White': ctaTypes['primaryWhite'],
  'CaseCE Primary Black': ctaTypes['primaryBlack'],
  'CaseCE Secondary Black': ctaTypes['secondaryBlack'],
  'CaseCE Secondary White': ctaTypes['secondaryWhite'],
};

export type TGenericPopUpParams = Partial<{
  ctaText: string;
  ctaStyles: keyof typeof CtaStylesCtaTypeObj;
  icon: string;
}>;

export type TGenericPopUpFields = Partial<{
  icon: TIconFromRenderingParams;
}>;

export type TGenericPopUpProps = IComponentProps<TGenericPopUpFields, TGenericPopUpParams> & {
  extraClassName?: string;
  children?: any;
  sitecoreContext: TSitecoreContext;
};
